require('./files/description');
require('./files/add-to-cart-personalized');
require('./files/motorbike-kit-personalized');
require('./files/reviews');
require('./files/review-images');
require('./files/review-images-carousel');

require('../../css/web/add-to-cart.css');
require('../../css/web/reviews.css');
require('../../sass/web/reviews-images.scss');
require('../../css/web/services.css');
require('../../css/web/personalized-sticker.css');
require('../../sass/web/personalized_services.scss');
require('../../sass/web/review.scss');
